module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/721b68b3daef0cdc09dd1c06bab83334.png";